import style from "../style/couponCodeDetail.module.scss";
import {Label104x46} from "../../../components/Label";
import React from "react";

interface Args{
    label: string;
    value: string;
}
export function DetailLabelAndValueField({label, value}:Args) {

    return (
        <div className={style.field}>
            <Label104x46 className={style.label} text={label}/>
            <span className={style.text}>{value}</span>
        </div>
    )
}